import { isEmpty } from "2g-utils-common";
import { useToLocaleDateString } from "b2b/i18n";
import createBaseRenderer from "./createBaseRenderer";

const optionsTermin = {
  month: "long",
  day: "numeric"
};

export default createBaseRenderer({
  name: "termin",
  placeholderText: "06. března, 14-22",
  content: ({ val }) => {
    const toLocaleDateString = useToLocaleDateString();
    if (isEmpty(val.datumOd) || isEmpty(val.datumDo)) return null;
    const datumOd = new Date(val.datumOd);
    const datumDo = new Date(val.datumDo);
    const formattedDo = `${toLocaleDateString(val.datumDo, optionsTermin)}, `;
    return `${toLocaleDateString(
      val.datumOd,
      optionsTermin
    )}, ${datumOd.getHours()} - ${
      datumOd.getDate() != datumDo.getDate() ? formattedDo : ""
    }${datumDo.getHours()}`;
  }
});
